import * as Yup from 'yup';
import { DB_PREFIX, DB_PREFIX_VACCINATED } from './constants';

export default Yup.object().shape({
  [DB_PREFIX_VACCINATED]: Yup.object().shape({
    vaccinated: Yup.boolean().required(),
  }),
  [DB_PREFIX]: Yup.object().when(`${DB_PREFIX_VACCINATED}.vaccinated`, {
    is: true,
    then: Yup.object().shape({
      vaccineType: Yup.string().required('Please select a vaccine type'),
      vaccineDateFirst: Yup.string().nullable(),
      vaccineDateSecond: Yup.string().nullable(),
    }),
  }),
});
